export default __webpack_public_path__ + "static/media/1.755aeb7d.png";